import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var es = {
  language: 'es',
  country: 'es',
  name: 'Español',
  embeddedLocale: merge(error, login),
  flags: ['ES'],
};

export { es as default };
